import { LocationDescriptorObject } from 'history';
import { CookieService } from 'ha/services/cookie';

import newTracker from './tracker';

const legacyCookieNames = {
  google: 'gclid',
  facebook: 'fbclid',
};

const getCookieName = (providerName: string): string =>
  legacyCookieNames[providerName] || providerName;

export default function newReduxTracker(cookie: CookieService) {
  // the key value store is implemented using the cookies module
  const keyValueStore = {
    get: (provider: string): string | undefined =>
      cookie.getCookie(getCookieName(provider)),
    set: (provider: string, value: string, expireInDays: number): void =>
      cookie.setCookie(getCookieName(provider), value, {
        expires: expireInDays,
      }),
  };

  const tracker = newTracker(keyValueStore);

  const getSource = () => tracker.getSource();
  const trackSource = (location: LocationDescriptorObject) =>
    tracker.trackSource(location);

  return {
    getSource,
    trackSource,
  };
}
